{
  "Dash": {"p":40,"s":35},
  "Throw Stone": {"p":40,"s":35},
  "Accumulate": {"p":50,"s":45},
  "Heal": {"p":72,"s":67},
  "Tickle": {"p":40,"s":35},
  "Yell": {"p":40,"s":35},
  "Cheer Up": {"p":35,"s":30},
  "Fury": {"p":35,"s":30},
  "Wish": {"p":40,"s":35},
  "Scream": {"p":25,"s":21},
  "Ultima": {"p":6,"s":5},
  "Potion": {"p":78,"s":73},
  "Hi-Potion": {"p":40,"s":34},
  "X-Potion": {"p":40,"s":34},
  "Ether": {"p":42,"s":37},
  "Hi-Ether": {"p":40,"s":35},
  "Elixir": {"p":4,"s":3},
  "Antidote": {"p":65,"s":60},
  "Eye Drop": {"p":65,"s":60},
  "Echo Grass": {"p":65,"s":59},
  "Maiden's Kiss": {"p":65,"s":58},
  "Soft": {"p":64,"s":57},
  "Holy Water": {"p":40,"s":35},
  "Remedy": {"p":40,"s":35},
  "Phoenix Down": {"p":85,"s":80},
  "Head Rend": {"p":40,"s":35},
  "Armor Rend": {"p":40,"s":35},
  "Shield Rend": {"p":40,"s":35},
  "Weapon Rend": {"p":40,"s":35},
  "Magic Ruin": {"p":40,"s":35},
  "Speed Break": {"p":40,"s":35},
  "Power Break": {"p":40,"s":35},
  "Mind Break": {"p":40,"s":35},
  "Stasis Sword": {"p":25,"s":21},
  "Justice Sword": {"p":32,"s":27},
  "Dark Sword": {"p":22,"s":19},
  "Night Sword": {"p":20,"s":17},
  "Surging Sword": {"p":15,"s":13},
  "Explosion Sword": {"p":7,"s":6},
  "Charge+1": {"p":55,"s":51},
  "Charge+2": {"p":40,"s":35},
  "Charge+3": {"p":40,"s":35},
  "Charge+4": {"p":40,"s":35},
  "Charge+5": {"p":40,"s":35},
  "Charge+7": {"p":40,"s":35},
  "Charge+10": {"p":30,"s":25},
  "Charge+20": {"p":21,"s":17},
  "Spin Fist": {"p":40,"s":35},
  "Pummel": {"p":40,"s":35},
  "Wave Fist": {"p":40,"s":35},
  "Earth Slash": {"p":40,"s":35},
  "Secret Fist": {"p":40,"s":35},
  "Purification": {"p":80,"s":75},
  "Chakra": {"p":45,"s":40},
  "Revive": {"p":71,"s":66},
  "Seal Evil": {"p":35,"s":30},
  "Cure": {"p":50,"s":45},
  "Cure 2": {"p":40,"s":35},
  "Cure 3": {"p":40,"s":35},
  "Cure 4": {"p":35,"s":30},
  "Raise": {"p":80,"s":75},
  "Raise 2": {"p":40,"s":35},
  "Reraise": {"p":40,"s":35},
  "Regen": {"p":40,"s":35},
  "Protect": {"p":40,"s":35},
  "Protect 2": {"p":40,"s":35},
  "Shell": {"p":40,"s":35},
  "Shell 2": {"p":40,"s":35},
  "Wall": {"p":40,"s":35},
  "Esuna": {"p":85,"s":80},
  "Holy": {"p":30,"s":25},
  "Magic Barrier": {"p":6,"s":5},
  "Fire": {"p":40,"s":35},
  "Fire 2": {"p":40,"s":35},
  "Fire 3": {"p":40,"s":35},
  "Fire 4": {"p":35,"s":30},
  "Bolt": {"p":40,"s":35},
  "Bolt 2": {"p":40,"s":35},
  "Bolt 3": {"p":40,"s":35},
  "Bolt 4": {"p":35,"s":30},
  "Ice": {"p":40,"s":35},
  "Ice 2": {"p":40,"s":35},
  "Ice 3": {"p":40,"s":35},
  "Ice 4": {"p":35,"s":30},
  "Empower": {"p":30,"s":25},
  "Frog": {"p":24,"s":20},
  "Death": {"p":25,"s":21},
  "Flare": {"p":28,"s":23},
  "Haste": {"p":59,"s":54},
  "Haste 2": {"p":40,"s":35},
  "Slow": {"p":40,"s":35},
  "Slow 2": {"p":40,"s":35},
  "Stop": {"p":40,"s":35},
  "Immobilize": {"p":40,"s":35},
  "Float": {"p":40,"s":35},
  "Reflect": {"p":43,"s":38},
  "Quick": {"p":40,"s":35},
  "Demi": {"p":40,"s":35},
  "Demi 2": {"p":40,"s":35},
  "Mute": {"p":40,"s":35},
  "Old": {"p":35,"s":30},
  "Stabilize Time": {"p":68,"s":63},
  "Meteor": {"p":25,"s":21},
  "Galaxy Stop": {"p":5,"s":5},
  "Moogle": {"p":75,"s":70},
  "Shiva": {"p":40,"s":35},
  "Ramuh": {"p":40,"s":35},
  "Ifrit": {"p":40,"s":35},
  "Titan": {"p":40,"s":35},
  "Golem": {"p":40,"s":35},
  "Carbunkle": {"p":60,"s":56},
  "Bahamut": {"p":19,"s":17},
  "Odin": {"p":25,"s":21},
  "Leviathan": {"p":40,"s":35},
  "Salamander": {"p":35,"s":30},
  "Sylph": {"p":40,"s":35},
  "Fairy": {"p":40,"s":35},
  "Lich": {"p":30,"s":25},
  "Cyclops": {"p":22,"s":19},
  "Zodiac": {"p":3,"s":3},
  "Gil Taking": {"p":39,"s":34},
  "Steal Heart": {"p":41,"s":36},
  "Steal Helmet": {"p":40,"s":35},
  "Steal Armor": {"p":40,"s":35},
  "Steal Shield": {"p":40,"s":35},
  "Steal Weapon": {"p":40,"s":35},
  "Steal Accessory": {"p":40,"s":35},
  "Steal Status": {"p":32,"s":27},
  "Arm Aim": {"p":35,"s":30},
  "Leg Aim": {"p":35,"s":30},
  "Invitation": {"p":40,"s":35},
  "Persuade": {"p":40,"s":35},
  "Praise": {"p":40,"s":35},
  "Threaten": {"p":40,"s":35},
  "Preach": {"p":40,"s":35},
  "Solution": {"p":40,"s":35},
  "Death Sentence": {"p":40,"s":35},
  "Insult": {"p":40,"s":35},
  "Negotiate": {"p":40,"s":35},
  "Mimic Daravon": {"p":40,"s":35},
  "Refute": {"p":70,"s":65},
  "Rehabilitate": {"p":40,"s":35},
  "Blind": {"p":40,"s":35},
  "Poison": {"p":40,"s":35},
  "Life Drain": {"p":40,"s":35},
  "Spell Absorb": {"p":40,"s":35},
  "Pray Faith": {"p":35,"s":30},
  "Doubt Faith": {"p":35,"s":30},
  "Zombie": {"p":40,"s":35},
  "Silence": {"p":40,"s":35},
  "Enrage": {"p":40,"s":35},
  "Foxbird": {"p":40,"s":35},
  "Confuse": {"p":40,"s":35},
  "Paralyze": {"p":40,"s":35},
  "Sleep": {"p":40,"s":35},
  "Petrify": {"p":25,"s":21},
  "Dispel Magic": {"p":70,"s":65},
  "Dark Holy": {"p":30,"s":25},
  "Pitfall": {"p":64,"s":64},
  "Water Ball": {"p":64,"s":64},
  "Hell Ivy": {"p":64,"s":64},
  "Hallowed Ground": {"p":64,"s":64},
  "Local Quake": {"p":64,"s":64},
  "Static Shock": {"p":64,"s":64},
  "Will-O-Wisp": {"p":64,"s":64},
  "Quicksand": {"p":64,"s":64},
  "Sand Storm": {"p":64,"s":64},
  "Blizzard": {"p":64,"s":64},
  "Gusty Wind": {"p":64,"s":64},
  "Lava Ball": {"p":64,"s":64},
  "Level Jump7": {"p":22,"s":21},
  "Level Jump6": {"p":19,"s":19},
  "Level Jump5": {"p":17,"s":17},
  "Level Jump4": {"p":15,"s":15},
  "Level Jump3": {"p":14,"s":14},
  "Level Jump2": {"p":13,"s":13},
  "Vertical Jump7": {"p":22,"s":21},
  "Vertical Jump6": {"p":19,"s":19},
  "Vertical Jump5": {"p":17,"s":17},
  "Vertical Jump4": {"p":15,"s":15},
  "Vertical Jump3": {"p":14,"s":14},
  "Vertical Jump2": {"p":13,"s":13},
  "Asura": {"p":53,"s":50},
  "Koutetsu": {"p":48,"s":43},
  "Bizen Boat": {"p":50,"s":45},
  "Murasame": {"p":41,"s":34},
  "Heaven's Cloud": {"p":40,"s":33},
  "Kiyomori": {"p":35,"s":32},
  "Muramasa": {"p":27,"s":18},
  "Kikuichimonji": {"p":32,"s":23},
  "Masamune": {"p":5,"s":4},
  "Chirijiraden": {"p":4,"s":3},
  "Shuriken": {"p":60,"s":55},
  "Bomb": {"p":45,"s":40},
  "Knife": {"p":16,"s":14},
  "Sword": {"p":6,"s":5},
  "Hammer": {"p":5,"s":4},
  "Staff": {"p":7,"s":7},
  "Ninja Sword": {"p":7,"s":7},
  "Axe": {"p":6,"s":5},
  "Spear": {"p":7,"s":6},
  "Stick": {"p":7,"s":7},
  "Wand": {"p":7,"s":7},
  "Dictionary": {"p":6,"s":6},
  "Angel Song": {"p":40,"s":35},
  "Life Song": {"p":40,"s":35},
  "Cheer Song": {"p":40,"s":35},
  "Battle Song": {"p":40,"s":35},
  "Magic Song": {"p":40,"s":35},
  "Nameless Song": {"p":30,"s":25},
  "Last Song": {"p":35,"s":30},
  "Space Storage": {"p":26,"s":22},
  "Diamond Blade": {"p":30,"s":25},
  "Sky Demon": {"p":30,"s":25},
  "Hydra Pit": {"p":30,"s":25},
  "Witch Hunt": {"p":40,"s":35},
  "Wiznaibus": {"p":40,"s":35},
  "Slow Dance": {"p":40,"s":35},
  "Polka Polka": {"p":40,"s":35},
  "Disillusion": {"p":40,"s":35},
  "Nameless Dance": {"p":30,"s":25},
  "Last Dance": {"p":35,"s":30},
  "Void Storage": {"p":26,"s":22},
  "Obsidian Blade": {"p":30,"s":25},
  "Nether Demon": {"p":30,"s":25},
  "Dragon Pit": {"p":30,"s":25}
}
